import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { performGateLogin } from "../services/gateAuth";

function GateLogin() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  const code = searchParams.get("code");
  const gateInstance = searchParams.get("gi");
  const gateReturnUrl = searchParams.get("return");
  const hintEmail = searchParams.get("he");

  useEffect(() => {
    if (!code) {
      setError("Geçersiz giriş bağlantısı");
      setTimeout(() => navigate("/login"), 2500);
      return;
    }

    const guardKey = `gateLogin:${code}`;
    const guardState = sessionStorage.getItem(guardKey);
    if (guardState === "pending") {
      return;
    }
    if (guardState === "done") {
      window.location.assign("/");
      return;
    }

    const runGateLogin = async () => {
      sessionStorage.setItem(guardKey, "pending");
      try {
        await performGateLogin(code, gateInstance, gateReturnUrl, hintEmail);
        sessionStorage.setItem(guardKey, "done");
      } catch (err: any) {
        sessionStorage.removeItem(guardKey);
        const errorCode = err?.response?.data?.errorCode;
        const message =
          errorCode === "GATE_TARGET_USER_NOT_FOUND"
            ? "Hedef sistem bilgileriniz bulunamadı"
            : "Gate üzerinden giriş başarısız oldu";
        setError(message);
        setTimeout(() => navigate("/login"), 3000);
      }
    };

    void runGateLogin();
  }, [code, gateInstance, gateReturnUrl, hintEmail, navigate]);

  if (error) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ maxWidth: 420, padding: 24, textAlign: "center" }}>
          <p style={{ color: "#ef4444", marginBottom: 16 }}>{error}</p>
          <p style={{ color: "#6b7280" }}>Giriş sayfasına yönlendiriliyorsunuz…</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ textAlign: "center" }}>
        <div
          style={{
            width: 48,
            height: 48,
            margin: "0 auto 16px",
            border: "2px solid #e5e7eb",
            borderTopColor: "#16a34a",
            borderRadius: "50%",
            animation: "gate-login-spin 0.8s linear infinite",
          }}
        />
        <p style={{ color: "#6b7280" }}>Gate üzerinden giriş yapılıyor…</p>
      </div>
      <style>{`
        @keyframes gate-login-spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default GateLogin;
